import { type ReactNode } from "react";
import { Link, useLocation } from "@/lib/router-compat";
import { cn } from "@/lib/utils";

interface NavLinkCompatProps {
  to: string;
  children: ReactNode;
  className?:
    string | ((props: { isActive: boolean; isPending: boolean }) => string);
  end?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
}

export function NavLink({
  to,
  children,
  className,
  end,
  onClick,
  onMouseEnter,
}: NavLinkCompatProps) {
  const { pathname } = useLocation();
  const isActive = end
    ? pathname === to
    : pathname === to || (to !== "/" && pathname.startsWith(`${to}/`));
  const resolvedClassName =
    typeof className === "function"
      ? className({ isActive, isPending: false })
      : className;

  return (
    <Link
      to={to}
      className={cn(resolvedClassName)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      {children}
    </Link>
  );
}
